// extracted by mini-css-extract-plugin
module.exports = {"loader":"DotsLoader_loader__jf3Vv","dot":"DotsLoader_dot__quzk9","wave":"DotsLoader_wave__yuS7G"};